import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const churchRolesOptions = [
  "Umujyanama",
  "Umuririmbyi",
  "Protocol",
  "Technic",
  "Umunyamasengesho",
  "Umuvugabutumwa",
  "Umuyobozi w'itsinda",
  "Umupasitori (Pastor)",
  "Umukirisitu usanzwe"
];

const choirGroups = [
  "Narada",
  "Byiringiro",
  "Fruta Melody",
  "Reverence",
  "Maranata",
  "Ebenezer"
];

const schoolOptions = ["Kanombe", "Gahanga", "Kicukiro"];

const cellOptions = [
  "Kicukiro", "Kagarama-Niboye", "Kabeza-Kanombe", "Nyarugenge",
  "Kimironko", "Nyabisindu", "Gatenga", "Kagugu-Batsinda",
  "Kimisagara", "Gatsata-Bweramvura", "Gikondo-Kigarama", "Remera",
  "Kagina", "Karembure", "Rwabutenge", "Nyakabungo", "Kabuga",
  "Ntatsinda ubarizwamo", "Rwanko", "Nyirakanamba", "Nyabyunyu",
  "Antenne", "Gatovu", "Kiyanja", "Kagasa"
];

const UpdateChurchInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    church_roles: [],
    choir_member: '',
    choir_group: '',
    school: '',
    cell: ''
  });

  useEffect(() => {
    if (christian) {
      const roles = christian.church_roles ? christian.church_roles.split(', ') : [];
      setFormData({
        church_roles: roles,
        choir_member: roles.includes("Umuririmbyi") ? 'Yes' : 'No',
        choir_group: roles.includes("Umuririmbyi") ? christian.choir_group || '' : '',
        school: christian.school || '',
        cell: christian.cell || ''
      });
    }
  }, [christian]);

  const handleChurchRoleChange = (role) => {
    setFormData(prev => {
      const newRoles = prev.church_roles.includes(role)
        ? prev.church_roles.filter(r => r !== role)
        : [...prev.church_roles, role];
      
      const isChoirMember = newRoles.includes("Umuririmbyi");

      return {
        ...prev,
        church_roles: newRoles,
        choir_member: isChoirMember ? 'Yes' : 'No',
        choir_group: isChoirMember ? prev.choir_group : ''
      };
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const dataToSend = {
        ...formData,
        church_roles: formData.church_roles.join(', ')
      };

      if (dataToSend.choir_member !== 'Yes') {
        dataToSend.choir_group = '';
      }

      await axios.put(
        `${API_BASE_URL}/christian/update/${christian.id}`,  // CHANGE THIS LINE
        dataToSend
      );
      onUpdate();
    } catch (error) {
      console.error("Error updating church info:", error);
      alert("Failed to update church info. Check console for details.");
    }
  };

  const isChoirMember = formData.church_roles.includes("Umuririmbyi");

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Church Roles Section */}
      <div className="border-b border-gray-200 pb-4">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          {data.allChristianTable.church_roles}
        </h3>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {churchRolesOptions.map((role) => (
            <div key={role} className="flex items-start">
              <div className="flex items-center h-5">
                <input
                  id={`role-${role}`}
                  name="church_roles"
                  type="checkbox"
                  checked={formData.church_roles.includes(role)}
                  onChange={() => handleChurchRoleChange(role)}
                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor={`role-${role}`} className="font-medium text-gray-700">
                  {role}
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Choir Group Section */}
      {isChoirMember && (
        <div className="border-b border-gray-200 pb-4">
          <h3 className="text-lg font-medium leading-6 text-gray-900">
            {data.allChristianTable.choir_group}
          </h3>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {choirGroups.map((group) => (
              <div key={group} className="flex items-center">
                <input
                  id={`group-${group}`}
                  name="choir_group"
                  type="radio"
                  value={group}
                  checked={formData.choir_group === group}
                  onChange={handleChange}
                  className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
                />
                <label htmlFor={`group-${group}`} className="ml-3 block text-sm font-medium text-gray-700">
                  {group}
                </label>
              </div>
            ))}
            <div className="flex items-center">
              <input
                id="group-none"
                name="choir_group"
                type="radio"
                value=""
                checked={formData.choir_group === ''}
                onChange={handleChange}
                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor="group-none" className="ml-3 block text-sm font-medium text-gray-700">
                None
              </label>
            </div>
          </div>
        </div>
      )}

      {/* School Section */}
      <div className="border-b border-gray-200 pb-4">
        <h3 className="text-lg font-medium leading-6 text-gray-900">
          {data.allChristianTable.school}
        </h3>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {schoolOptions.map((school) => (
            <div key={school} className="flex items-center">
              <input
                id={`school-${school}`}
                name="school"
                type="radio"
                value={school}
                checked={formData.school === school}
                onChange={handleChange}
                className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
              />
              <label htmlFor={`school-${school}`} className="ml-3 block text-sm font-medium text-gray-700">
                {school}
              </label>
            </div>
          ))}
        </div>
      </div>

      {/* Cell/Location Section */}
      <div className="border-b border-gray-200 pb-4">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Cell / Area</h3>
        <div className="mt-4">
          <select
            name="cell"
            value={formData.cell}
            onChange={handleChange}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          >
            <option value="">Select Cell</option>
            {cellOptions.map(cell => (
              <option key={cell} value={cell}>{cell}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateChurchInfo;